import React from "react"
import PropTypes from "prop-types"
import { primitives } from '@lexody/design-tokens'

import Icon from '../app_components/Icon'
import NotificationSection from './NotificationSection'

class NotificationBell extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      unreadCount: 0,
    }

    this.notificationSectionRef = React.createRef()
    this.openNotifications = this.openNotifications.bind(this)
    this.closeNotifications = this.closeNotifications.bind(this)
    this.handleCountChange = this.handleCountChange.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.props.refreshTrigger !== prevProps.refreshTrigger && this.notificationSectionRef.current) {
      this.notificationSectionRef.current.getNotifications()
    }
  }

  openNotifications() {
    this.setState({ open: true })
  }

  closeNotifications() {
    this.setState({ open: false })
  }

  handleCountChange(count) {
    this.setState({ unreadCount: count })
  }

  render() {
    const { unreadCount, open } = this.state

    return (
      <div className="notificationBellWrap">
        {unreadCount > 0 &&
          <button
            type="button"
            className="notificationBell"
            onClick={this.openNotifications}
            aria-label={`Notifications, ${unreadCount} unread`}
          >
            <Icon name="bell" size={22} color={primitives.blue['800']} />
            <span className="notificationBell__dot" aria-hidden="true" />
          </button>
        }
        <NotificationSection
          ref={this.notificationSectionRef}
          inModal
          isOpen={open}
          onClose={this.closeNotifications}
          onCountChange={this.handleCountChange}
          confettiLottie={this.props.confettiLottie}
          lexicoin={this.props.lexicoin}
          closeIcon={this.props.closeIcon}
        />
      </div>
    )
  }
}

NotificationBell.propTypes = {
  confettiLottie: PropTypes.string,
  lexicoin: PropTypes.string,
  closeIcon: PropTypes.string,
  refreshTrigger: PropTypes.number,
}

export default NotificationBell
